import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NgOtpInputModule } from 'ng-otp-input';
import { SharedModule } from '@shared';
import { MaterialModule } from '@app/material.module';
import { I18nModule } from '@app/i18n';
import { AuthRoutingModule } from './auth-routing.module';
import { LoginComponent } from './login.component';
import { BasicInfoComponent } from './register/create-account/basic-info/basic-info.component';
import { CreateAccountComponent } from './register/create-account/create-account.component';
import { VerifyOtpComponent } from './register/create-account/verify-otp/verify-otp.component';
import { SplashScreenSlidersComponent } from './splash-screen-sliders/splash-screen-sliders.component';
import { NumberTranslatePipeModule } from '@app/@shared/pipes/number-translate/number-translate.module';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { ReactivateAccountComponent } from './reactivate-account/reactivate-account.component';
import { ForceResetPasswordDialogComponent } from './force-reset-password-dialog/force-reset-password-dialog.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    SharedModule,
    MaterialModule,
    I18nModule,
    AuthRoutingModule,
    NumberTranslatePipeModule,
    NgOtpInputModule,
  ],
  declarations: [
    LoginComponent,
    BasicInfoComponent,
    CreateAccountComponent,
    VerifyOtpComponent,
    SplashScreenSlidersComponent,
    ForgotPasswordComponent,
    ReactivateAccountComponent,
    ForceResetPasswordDialogComponent,
  ],
})
export class AuthModule {}
